// extracted by mini-css-extract-plugin
export default {"textBlock":"style_textBlock__LgcQv","sectionRow":"style_sectionRow__SRxDW","sectionHeader":"style_sectionHeader__Q5kKp","wrapWidth":"style_wrapWidth__J-zyt"};